import React from 'react';
import PropTypes from 'prop-types';

const SitecoreImageField = (props) => {
    const hasImageData = (props.img !== undefined && props.img !== '' && props.img.src !== undefined && props.img.src !== '');

    return (
        hasImageData &&
        <img
            className={props.className}
            alt={props.img.alt}
            src={props.img.src}
        />
    );
};

SitecoreImageField.propTypes = {
    img: PropTypes.object,
    className: PropTypes.string
};

export default SitecoreImageField;
